import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1248e719"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "showForm",
  id: "showForm",
  class: "showForm"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Contact Us"),
  /*#__PURE__*/_createElementVNode("form", {
    action: "https://public.herotofu.com/v1/88ecf510-86fa-11ed-b38f-a1ed22f366b1",
    method: "post"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "left section" }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "text",
        name: "name",
        placeholder: "Your name",
        required: ""
      }),
      /*#__PURE__*/_createElementVNode("input", {
        type: "email",
        name: "email",
        placeholder: "Your email",
        required: ""
      }),
      /*#__PURE__*/_createElementVNode("input", {
        type: "tel",
        name: "tel",
        placeholder: "Your telephone number",
        required: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "right section" }, [
      /*#__PURE__*/_createElementVNode("textarea", {
        name: "comment",
        placeholder: "Your comment",
        required: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "sendForm left"
    }, "Send"),
    /*#__PURE__*/_createElementVNode("label", {
      for: "showForm",
      class: "closeFormLabel left"
    }, "X")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "show-form-container" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "showForm",
    class: "showFormLabel"
  }, "get in touch")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ], 64))
}